
/// <amd-module name="Run/Extensions/RunTabService" />
import React = require("react");

import { IBuildRestClient } from "Build/Client/RestClient/Build";
import { IRunViewContributedTabProps } from 'Build/Run/RunViewContributedTab';
import { IContribution, LegacySection } from "Run/Extensions/Components/LegacySection";
import { MarkdownCard } from "Run/Extensions/Components/MarkdownCard";
import { Region, RunTimeline } from "Run/Extensions/Components/Timeline";
import * as Resources from "Run/Extensions/Resources";
import { IReadonlyObservableArray, ObservableArray } from "VSS/Core/Observable";
import { getContributedItems } from "VSS/Features/PlatformUI/ContributedItemUtil";
import { ITabService } from "VSS/Features/PlatformUI/ContributedTab";
import { IVssPageContext, Services, VssService } from "VSS/Platform/Context";
import { IVssLayoutManager } from "VSS/Platform/Layout";
import { IVssContributedTab } from "VSSUI/Tabs.Types";

export class RunTabService extends VssService implements ITabService<IRunViewContributedTabProps> {
    private _data: IRunViewContributedTabProps | undefined;
    private _tabs = new ObservableArray<IVssContributedTab>();
    private _tab: IVssContributedTab = {
        id: "ms.vss-build-web.run-extensions-tab",
        name: Resources.TabName,
        order: 100 // push to the end
    };
    public getTabs(tabId: string, contextualData?: IRunViewContributedTabProps): IVssContributedTab[] | IReadonlyObservableArray<IVssContributedTab> {
        this._data = contextualData;
        if (this._data) {
            this._fetch();
            this._data.status.subscribe(this._fetch);
        }
        return this._tabs;
    }

    public _serviceEnd(pageContext: IVssPageContext): void {
        if (this._data) {
            this._data.status.unsubscribe(this._fetch);
        }
    }

    private _fetch = async () => {
        if (this._data) {
            const buildId = this._data.runId.value;
            const projectId = this._data.projectId.value;
            const buildClient = this.pageContext.getRestClient<IBuildRestClient>("IBuildRestClient");
            const build = await buildClient.getBuild(projectId, buildId);
            
            const attachments1 = await buildClient.getAttachments(projectId, buildId, "DistributedTask.Core.Summary") || [];
            // DT timeline strings are changed to being case sensitive, so for compat-
            const attachments2 = await buildClient.getAttachments(projectId, buildId, "Distributedtask.Core.Summary") || [];
            const attachments = attachments1.concat(attachments2);

            const layoutManager = this.pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
            const contributedSnapshots = layoutManager.getComponentsForRegion(Region);
            if (attachments.length > 0 || contributedSnapshots.length > 0) {
                this._tab.render = () => <>
                    <RunTimeline
                        build={build}
                        projectId={projectId}
                    />
                    <MarkdownCard
                        data={attachments}
                    />
                </>
                if (this._tabs.length == 0) {
                    this._tabs.push(this._tab);
                }
            }
        }
    }
}

Services.add("run-ext-tab-service", { serviceFactory: RunTabService });
